import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";

// Import SEO optimization components
import AdvancedSEOSchema from "./components/AdvancedSEOSchema";
import SEOOptimization from "./components/SEOOptimization";

// Lazy load the HomePage component for code splitting
const HomePage = lazy(() => import("./pages/HomePage"));

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        {/* Global SEO Components */}
        <SEOOptimization />
        <AdvancedSEOSchema />
        
        <BrowserRouter>
          <Suspense fallback={
            <div className="min-h-screen bg-slate-900 flex items-center justify-center">
              <div className="text-white text-xl">Loading JyotixEdge...</div>
            </div>
          }>
            <Routes>
              <Route path="/" element={<HomePage />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;